import { BffApiClientMolecule } from "@/app/api-client/store"
import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { ProfileMoleculeReatom as ProfileMolecule } from "../store/index.reatom"
import { getUserBidsQueryParams } from "./utils"

export const UserBidsMoleculeReatom = molecule((mol) => {
  const { walletAddress } = mol(ProfileMolecule)
  const bffApiClient = mol(BffApiClientMolecule)
  const { blockchainsQueryFilter } = mol(BlockchainFiltersMoleculeReatom)

  // Create dynamic query params that depend on blockchainsQueryFilter
  const queryParamsAtom = computed(() => {
    const blockchains = blockchainsQueryFilter()
    return {
      ...getUserBidsQueryParams(bffApiClient, {
        address: walletAddress,
        blockchains,
      }),
      refetchInterval: 3000,
    }
  }, "userBidsQueryParams")

  return { queryParamsAtom }
})
